import React, { useState } from 'react'
//import video from '../../video/Code27920.mp4'
//import video from '../../video/Line46957.mp4'
import desktopVideo from '../../video/v720.m4v'
import tabletVideo from '../../video/v480.m4v'
import mobileVideo from '../../video/v480.m4v'

import bg from '../../img/bg/group.jpg';

import logo2 from '../../img/logo.png';


import {
    LandingContainer,
    WaveContainer,
    VideoBg,
    LandingContent,
    LandingContentWrapper,
    LandingH1,
    LandingP,
    LandingBtnWrapper,
    LandingBg,
    Logo,
   
} from './LandingElements'
import { Button } from '../ButtonElement';

const getVideoSrc = width => {
    if (width >= 1080) return desktopVideo;
    if (width >= 720) return tabletVideo;
    return mobileVideo;
  };

  const video = getVideoSrc(window.innerWidth);

const HeroSection = ({isLandscape,fixLandscape}) => {
    const [hover, setHover] = useState(false);

    const onHover = () => {
        setHover(!hover);
    }

    return (
        <LandingContainer id='home'>
            <LandingBg>
                <VideoBg playsInline autoPlay loop muted src={video} type="video/mp4"/>
            </LandingBg>
        <WaveContainer>
            <LandingContentWrapper>
                <LandingContent>
                    <LandingH1>
                        We are the solution in 
                        legal process services.
                    </LandingH1>
                    
                    <Logo image={logo2} image2={logo2} scroll={false} />

                    <LandingP>
                    Our firm offers comprehensice legal services!
                    {/* Our firm offers comprehensice legal services across non-litigation and litigation areas, grounded in a stron commintment to the advocate code of ethics! */}
                    </LandingP>
                <LandingH1>
                       619-960-5293
                    </LandingH1>

                    {/* <Button to="contact"
                                        smooth={true}
                                        duration={500}
                                        spy={true}
                                        exact="true"
                                        offset={-140}
                                        activeClass="active" 
                                        onMouseEnter={onHover} 
                                        onMouseLeave={onHover}
                            >
                            Contact Us
                    </Button> */}
             </LandingContent>

            </LandingContentWrapper>
         </WaveContainer>
       </LandingContainer>
    )
}

export default HeroSection  
